import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BarChart2 } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 bg-navy-900 overflow-hidden min-h-[90vh] flex items-center" data-id="element-61">
      {/* Geometric Background Accents */}
      <div className="absolute inset-0 bg-grid-pattern-light opacity-[0.03] pointer-events-none" data-id="element-62"></div>

      {/* Decorative Shapes */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.5,
      ease: 'easeOut'
    }} className="absolute top-20 right-[10%] w-64 h-64 border border-white/10 rounded-full pointer-events-none" data-id="element-63" />
      <motion.div initial={{
      opacity: 0,
      rotate: -45
    }} animate={{
      opacity: 1,
      rotate: 0
    }} transition={{
      duration: 1,
      delay: 0.2
    }} className="absolute bottom-20 left-[5%] w-32 h-32 border border-white/10 clip-triangle pointer-events-none" data-id="element-64" />
      <div className="absolute top-1/3 right-[5%] w-16 h-16 bg-white/5 clip-hexagon pointer-events-none" data-id="element-65"></div>

      <div className="container mx-auto px-6 max-w-7xl relative z-10" data-id="element-66">
        <div className="max-w-4xl" data-id="element-67">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex items-center gap-3 mb-8" data-id="element-68">
            <div className="h-[1px] w-12 bg-navy-400" data-id="element-69"></div>
            <span className="text-navy-300 font-medium tracking-widest uppercase text-sm" data-id="element-70">
              B2B Content Architecture
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-5xl md:text-7xl font-heading font-bold text-white leading-[1.1] mb-8" data-id="element-71">
            Stop publishing. <br data-id="element-72" />
            Start driving{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-400" data-id="element-73">
              pipeline.
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-slate-300 mb-12 max-w-2xl leading-relaxed" data-id="element-74">
            We engineer research-driven content strategies for tech and SaaS
            companies. Transform your blog from a cost center into a measurable
            revenue engine.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-75">
            <a href="#solutions" className="bg-white text-navy-900 px-8 py-4 font-semibold hover:bg-slate-100 transition-colors flex items-center justify-center gap-2 group" data-id="element-76">
              See Our Approach
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-77" />
            </a>
            <a href="#results" className="border border-navy-700 text-white px-8 py-4 font-semibold hover:bg-navy-800 transition-colors flex items-center justify-center gap-2" data-id="element-78">
              <BarChart2 size={18} className="text-navy-400" data-id="element-79" />
              View Case Studies
            </a>
          </motion.div>
        </div>

        {/* Abstract Infographic Element */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 w-[400px] h-[500px]" data-id="element-80">
          <div className="relative w-full h-full border-l border-b border-navy-800 flex items-end p-8" data-id="element-81">
            {/* Chart Bars */}
            <div className="w-16 h-[30%] bg-navy-800 mr-4 relative group" data-id="element-82">
              <div className="absolute -top-8 left-0 text-xs text-navy-400 font-mono" data-id="element-83">
                Q1
              </div>
            </div>
            <div className="w-16 h-[45%] bg-navy-700 mr-4 relative" data-id="element-84">
              <div className="absolute -top-8 left-0 text-xs text-navy-400 font-mono" data-id="element-85">
                Q2
              </div>
            </div>
            <div className="w-16 h-[70%] bg-navy-600 mr-4 relative" data-id="element-86">
              <div className="absolute -top-8 left-0 text-xs text-navy-400 font-mono" data-id="element-87">
                Q3
              </div>
            </div>
            <div className="w-16 h-[100%] bg-white relative" data-id="element-88">
              <div className="absolute -top-8 left-0 text-xs text-white font-mono font-bold" data-id="element-89">
                Q4
              </div>
              <div className="absolute -top-3 -right-3 w-6 h-6 bg-navy-900 border-2 border-white rounded-full" data-id="element-90"></div>
            </div>

            {/* Trend Line */}
            <svg className="absolute inset-0 w-full h-full pointer-events-none" preserveAspectRatio="none" data-id="element-91">
              <path d="M 40 350 L 120 275 L 200 150 L 280 0" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="2" strokeDasharray="4 4" data-id="element-92" />
            </svg>
          </div>
        </motion.div>
      </div>
    </section>;
}